import {
    GET_FEEDBACK_DOCUMENTS_LIST, GET_FEEDBACK_DOCUMENTS_LIST_SUCCESS, GET_FEEDBACK_DOCUMENTS_LIST_FAILED,
    SUBMIT_DOCUMENTS_LIST, SUBMIT_DOCUMENTS_LIST_SUCCESS, SUBMIT_DOCUMENTS_LIST_FAILED
} from "./actionTypes"

const initialState = {
    loading: false,
    submitDocumentData: null,
    submitDocumentSuccess: null,
    submitDocumentFail: null,
    submitSuccessMsg: null,
    submitErrorMsg: null
}

const submitDocumentReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_FEEDBACK_DOCUMENTS_LIST:
            state = {
                ...state,
                loading: true,
                submitDocumentData: null,
            }
            break
        case GET_FEEDBACK_DOCUMENTS_LIST_SUCCESS:
            state = {
                ...state,
                loading: false,
                submitDocumentData: action.payload,
            }
            break
        case GET_FEEDBACK_DOCUMENTS_LIST_FAILED:
            state = {
                ...state,
                loading: false,
                submitDocumentData: null,
                submitDocumentFail: action.payload
            }
            break
        case SUBMIT_DOCUMENTS_LIST:
            state = {
                ...state,
                loading: true,
                submitSuccessMsg: null,
                submitErrorMsg: null
            }
            break
        case SUBMIT_DOCUMENTS_LIST_SUCCESS:
            state = {
                ...state,
                loading: false,
                submitSuccessMsg: action.payload,
                submitErrorMsg: null
            }
            break
        case SUBMIT_DOCUMENTS_LIST_FAILED:
            state = {
                ...state,
                loading: false,
                submitSuccessMsg: null,
                submitErrorMsg: action.payload
            }
            break
        default:
            state = { ...state }
            break
    }
    return state
}
export default submitDocumentReducer